import React from 'react'
import BannerUpdate from '../banner_components/banner_update'
import WebSidebar from '../../web_sidebar'
export default function
    () {
    return (
        <div>
            <div className='row'>

                <WebSidebar />


                <div className='content-wrapper w-75 bg-white p-5'>
                    <div>
                        <h2>Update Banner</h2>
                        <BannerUpdate />
                    </div>


                </div>
            </div>




        </div>
    )
}
